
import { defineComponent, ref } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";

const EMPLOYER_ILR_SERVICE_REQUEST_ALIAS = "employer_ilr";

export default defineComponent({
  name: "ILRPopup",

  emits: ["ok", "cancel"],

  setup(_, { emit }) {
    const isPopoverOpen = ref(true);

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    async function submitRequest() {
      const alias = EMPLOYER_ILR_SERVICE_REQUEST_ALIAS;

      if (!alias) return;

      try {
        await axios.get(API_ROUTES.SERVICE_REQUEST(alias));
      } finally {
        onCancel();
      }
    }

    const onOk = () => {
      emit("ok");

      submitRequest();
    };

    return {
      isPopoverOpen,
      onOk,
      onCancel,
    };
  },
});
